import styled, { css } from 'styled-components';
import { rem } from 'polished';
import variables from '@styles/variables';
import Spinner from '@molecules/Spinner/Spinner';
import Button from '@atoms/Button/Button';
import Config from '@config';
import Input from '@atoms/Input/Input';
import StoreSearchEmptyState from '@molecules/StoreSearch/StoreSearchEmptyState';
import { comboboxInputOpen, comboboxDropdown } from '@styles/mixins/combobox';
import Form from '@molecules/Form/Form';

export const StyledStoreFinderForm = styled(Form)`
  display: flex;
  align-items: start;
  margin-bottom: ${rem(38)};
  gap: ${rem(20)};

  ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
    > button {
      flex-shrink: 0;
    }
  }

  ${Config.MEDIA.IS_MOBILE} {
    flex-direction: column;
    margin-bottom: ${rem(20)};
  }
`;

export const StyledMap = styled.div`
  width: 100%;
  height: ${rem(570)};

  // Override google styling

  .gm-style-iw {
    padding: 0 !important;

    > button {
      top: 0 !important;
      right: 0 !important;
    }
  }

  .gm-style-iw-d {
    overflow: hidden !important;
  }
`;

export const StyledInputField = styled(Input)<{ $open: boolean; $takeover: boolean }>`
  ${(props) =>
    props.$takeover &&
    css`
      margin: ${rem(16)};
    `}

  ${(props) =>
    props.$open &&
    css`
      ${comboboxInputOpen}
    `}
`;

export const StyledDropdown = styled.div<{ $isTakeover: boolean }>`
  background: ${variables.colors.white};

  ${comboboxDropdown}
  top: ${rem(50)};
  max-height: ${rem(300)};

  // Override Listbox's overflow-y: auto so this wrapper controls scrolling
  > div {
    overflow-y: visible;
  }

  ${(props) =>
    props.$isTakeover &&
    css`
      max-height: unset;
      height: 100%;
      top: ${rem(60)};
      margin-top: ${rem(24)};
      border-radius: 0;
    `}
`;

export const StyledContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(24)};
  height: 100%;
  justify-content: center;
  align-items: center;
`;

export const StyledModalButton = styled(Button)`
  width: 100%;

  ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
    width: ${rem(104)};
  }
`;

export const StyledSearchContainer = styled.div`
  position: relative;
  width: 100%;
  z-index: 10;
`;

export const StyledSpinner = styled(Spinner)`
  padding: ${rem(20)};
`;

export const StyledStoreSearchEmptyState = styled(StoreSearchEmptyState)`
  padding: ${rem(16)};
`;
